import * as React from 'react';
import { Typography } from '../Typography';

import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

interface ILabelProps {
  text: string;
  color?: 'primary' | 'currentColor';
  isDarkTheme?: boolean;
}

export const Label: React.FC<ILabelProps> = ({ text, color = 'primary', isDarkTheme = false }) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['label'], styles[deviceType], isDarkTheme && styles['dark-theme'])}>
      <Typography.Text level={5} color={color}>
        {text}
      </Typography.Text>
    </div>
  );
};

Label.displayName = 'Label';
